import { render, staticRenderFns } from "./SmallSelectField.vue?vue&type=template&id=5829d9aa&scoped=true"
import script from "./SmallSelectField.vue?vue&type=script&lang=js"
export * from "./SmallSelectField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5829d9aa",
  null
  
)

export default component.exports